export { default } from "./CarWhiteBgFirstThird";
